/* global $:true */

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

class Footer extends Component {
    goToTop = () => {
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    };

    render() {
        const { profile, brand } = this.props;

        return (
            <footer className="footer-2">
                <div className="pre-footer">
                    <div className="container">
                        <div id="to-top" onClick={this.goToTop}>
                            <i className="fa fa-angle-double-up" />
                        </div>
                        <div className="row">
                            <div className="ft col-md-6 col-sm-6">
                                <div className="quick-menu">
                                    <h2 className="title">Quick Menu</h2>
                                    <ul>
                                        <li><Link to="/resources">Resources <i className="fa fa-angle-right" /></Link></li>
                                        <li><a href="http://clevertykes.com/shop/" target="_blank">Shop <i className="fa fa-angle-right" /></a></li>
                                        {profile.isSchool ?
                                            <li><Link to="/book-session">Book enterprise session <i className="fa fa-angle-right" /></Link></li>
                                        : null}
                                        <li><Link to="/contact">Contact <i className="fa fa-angle-right" /></Link></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="ft col-md-6 col-sm-6">
                                <div className="about sponsor">
                                    <p className="lloyds-quote">
                                        <span dangerouslySetInnerHTML={{ __html: brand.quote }} />
                                    </p>
                                    <p>- {brand.quote_author}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer">
                    <div className="container">
                        <ul className="social-media">
                            <li><a href="https://twitter.com/clevertykes" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter" /></a></li>
                            <li><a href="https://www.facebook.com/CleverTykes" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook" /></a></li>
                            <li><a href="https://www.instagram.com/clevertykes/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram" /></a></li>
                        </ul>
                        <h5 className="copyright">Copyright &copy; 2017 All rights reserved.  Clever Tykes&reg;.  111 New Street, Birmingham, B2 4EU.</h5>
                    </div>
                </div>
            </footer>
        );
    }
}

Footer.propTypes = {
    profile: PropTypes.object,
    brand: PropTypes.object,
};

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/